import { render, staticRenderFns } from "./TransporteurList.vue?vue&type=template&id=6bb24bd4&scoped=true&"
import script from "./TransporteurList.vue?vue&type=script&lang=js&"
export * from "./TransporteurList.vue?vue&type=script&lang=js&"
import style0 from "./TransporteurList.vue?vue&type=style&index=0&id=6bb24bd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb24bd4",
  null
  
)

component.options.__file = "TransporteurList.vue"
export default component.exports